import { render, staticRenderFns } from "./CategoryDropdown.vue?vue&type=template&id=62f0e052&"
import script from "./CategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./CategoryDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports